


























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { isNotEmpty } from '@/ui/services/admin/InputVerification';
import getLogger from '@/shared/logger/logger';
import { CmsCredentialData } from '@/core/admin/models/CmsCredential';
import { CmsCredentialToCreateDTO } from '@/core/admin/DTO/CmsCredentialsDTO';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = getLogger('CmsCredentialsForm');

interface VForm extends HTMLFormElement {
  validate(): boolean;
  reset(): boolean;
}

@Component({
  name: 'CmsCredentialForm',
})
export default class CmsCredentialsForm extends Vue {
  @Prop({ default: false }) saveNew: boolean | undefined;
  @Prop({ default: false }) saveUpdate: boolean | undefined;
  @Prop({ default: undefined }) cmsCredentials: CmsCredentialData | undefined;
  @Prop({ default: false }) isEditForm: boolean | undefined;
  cmsUsername = '';
  cmsPassword = '';
  cmsGroupId = '';
  customerId = '';

  mounted(): void {
    this.$store.dispatch('adminStore/getAllCustomersWithoutCmsCredential');
    if (this.cmsCredentials) {
      this.setInputValues(this.cmsCredentials);
    }
  }

  get customersWithNoCmsCredentials() {
    return this.$store.state.adminStore.customersWithNoCmsCredentials;
  }

  @Watch('cmsCredentials')
  onStartingCmsCredentialChange() {
    if (this.cmsCredentials) {
      this.setInputValues(this.cmsCredentials);
    }
  }

  @Watch('saveNew')
  onSave(newValue: boolean) {
    if (this.isAllInputValid() && newValue) {
      const cmsCredentialsToCreate = new CmsCredentialToCreateDTO(
        this.customerId,
        this.cmsUsername,
        this.cmsPassword,
        this.cmsGroupId,
      );
      this.$emit('createCmsCredentialValidInput', cmsCredentialsToCreate);
    } else {
      this.$emit('inputIsInvalid');
    }
  }

  @Watch('saveUpdate')
  onUpdate(newValue: boolean) {
    if (this.cmsCredentials) {
      if (this.isAllInputValid() && newValue && this.cmsGroupId) {
        const cmsCredentialsToUpdate = new CmsCredentialToCreateDTO(
          this.customerId,
          this.cmsUsername,
          this.cmsPassword,
          this.cmsGroupId,
        );
        this.$emit('updateCmsCredentialValidInput', cmsCredentialsToUpdate);
      } else {
        this.$emit('inputIsInvalid');
      }
    }
  }

  get isNotEmpty() {
    return isNotEmpty;
  }

  isAllInputValid() {
    const ref = this.$refs.form as VForm;
    return ref.validate();
  }

  clearInput() {
    this.cmsUsername = '';
    this.cmsGroupId = '';
    this.customerId = '';
    this.cmsPassword = '';
    if (this.cmsCredentials) {
      this.setInputValues(this.cmsCredentials);
    }
  }

  setInputValues(cmsCredentials: CmsCredentialData): void {
    this.cmsUsername = cmsCredentials.cmsUsername;
    this.cmsGroupId = cmsCredentials.cmsGroupId;
    this.customerId = cmsCredentials.customer.id;
  }
}
